import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
export function PersonVisualMock() {
  useLanguage();
  return (
    <div className="relative w-full min-h-[400px] xl:min-h-[480px] flex items-center justify-center">
      {/* Glow central */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at 50% 50%, rgba(31, 107, 255, 0.15) 0%, transparent 60%)',
          filter: 'blur(40px)',
        }}
      />

      {/* Imagem Hero - Player HostVSL com pessoa */}
      <div className="relative z-10 rounded-2xl overflow-hidden">
        {/* Background azul sólido para eliminar transparência */}
        <div
          className="absolute inset-0 rounded-2xl"
          style={{
            background: 'linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)',
          }}
        />
        <img
          src="/assets/imgs/hero-vsl-creator.webp"
          alt={translateInterfaceText("HostVSL Player - Plataforma completa para VSLs")}
          className="relative z-10 max-w-[480px] xl:max-w-[560px] w-full h-auto object-contain"
          style={{
            filter: 'drop-shadow(0 25px 50px rgba(0, 0, 0, 0.25))',
            animation: 'fade-in 0.6s ease-out both',
          }}
        />
      </div>
    </div>
  );
}
